/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const OrganizationRole = zod.enum(['owner', 'member']);

export type OrganizationRole = zod.input<typeof OrganizationRole>;
export type OrganizationRoleOutput = zod.output<typeof OrganizationRole>;
